import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CertificationCard.module.css';

const CertificationCard = ({ description, href, img, issuer, standard, title }) => {
    const { i18n } = useTranslation();
    const language = i18n.language || 'en';
    const localizedHref = typeof href === 'string' ? href : href?.[language] || href?.en || href?.el;
    const localizedTitle = title?.[language] || title?.en || title?.el || title;
    const localizedDescription =
        description?.[language] || description?.en || description?.el || description;

    if (standard) {
        return (
            <a className={styles.isoRowContainer} href={localizedHref} target='_blank' rel='noreferrer'>
                <img className={styles.issuerLogo} src={img} alt='Certification img' />
                <div className={styles.isoCol}>
                    <div className={styles.isoRow}>
                        <span className={styles.issuer}>{issuer}</span>
                        <span className={styles.separator}>-</span>
                        <span className={styles.standard}>{standard}</span>
                        <span className={styles.separator}>-</span>
                        <span className={styles.title}>{localizedTitle}</span>
                    </div>
                    <div className={styles.isoRow}>
                        {localizedDescription && (
                            <>
                                {/* <span className={styles.separator}>-</span> */}
                                <span className={styles.description}>{localizedDescription}</span>
                            </>
                        )}
                    </div>
                </div>
            </a>
        );
    }

    return (
        <div className={styles.container}>
            <a href={localizedHref} target='_blank' rel='noreferrer'>
                <img src={img} alt='Certification img' />
            </a>
            <div>{localizedTitle}</div>
        </div>
    );
};

export default CertificationCard;
